import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import Api from "../../services/api";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import swal from "sweetalert";

import SelectBgAlinhamento from "../../components/SelectBgAlinhamento";
import SelectCidades from "../../components/SelectCidades";

const image_formats = ["image/jpg", "image/jpeg", "image/png"];

const validationSchema = yup.object().shape({
  cidade_id: yup.string().required("Cidade obrigatório"),
  alinhamento: yup.string().required("Alinhamento dA imagem obrigatório"),
  arquivo: yup
    .mixed()
    .test("required", "Selecione uma imagem ou video", (file) => {
      if (file.length === 0) {
        return false;
      } else {
        return true;
      }
    })
    .test(
      "fileSize",
      "Imagem maior que 1mb. Selecione uma imagem menor.",
      (file) => {
        if (file.length === 1) {
          return file[0].size <= 1000000 ? true : false;
        } else {
          return true;
        }
      },
    )
    .test(
      "FILE_FORMAT",
      "Imagem selecionada inválida. (Apenas jpg, jpeg e png)",
      (file) => {
        if (file.length === 1) {
          return image_formats.includes(file[0].type) ? true : false;
        } else {
          return true;
        }
      },
    ),
});

export default function NewSlideShow({ loadSlideShow, setOpenModalNew }) {
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;
  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitSuccessful, errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    // reset({ id: data.id})
  }, []);

  const onSubmit = (dataSlide) => {
    setLoading(true);
    const imagefile = document.querySelector("#arquivo");

    let bodyFormData = new FormData();
    bodyFormData.append("cidade_id", dataSlide.cidade_id);
    bodyFormData.append("nome", dataSlide.nome);
    bodyFormData.append("alinhamento", dataSlide.alinhamento);
    bodyFormData.append("botaoLabel", dataSlide.botaoLabel);
    bodyFormData.append("botaoLink", dataSlide.botaoLink);
    bodyFormData.append("arquivo", imagefile.files[0]);

    let axiosConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    Api.post("/slideshowhome/new", bodyFormData, axiosConfig)
      .then((response) => {
        if (response.data.status == "success") {
          swal("Sucesso!", response.data.message, "success");
          loadSlideShow();
          setOpenModalNew(false);
          setLoading(false);
        } else {
          swal("Erro!", response.data.message, "error");
          setLoading(false);
        }
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <h2>Novo Slide Show </h2>
      <form onSubmit={handleSubmit(onSubmit)} enctype="multipart/form-data">
        <Grid container className="form">
          <Grid item lg={12} md={6} sm={12} xs={12} className="field">
            <label>Cidade</label>
            <SelectCidades register={register("cidade_id")} />
            <span className="error">{errors.cidade_id?.message}</span>
          </Grid>
          <Grid item lg={6} md={6} sm={12} sx={12} className="field">
            <label>Imagem/video</label>
            <p>(Dimensões da imagem: 1440px x 900px)</p>
            <input
              type="file"
              nome="arquivo"
              id="arquivo"
              {...register("arquivo")}
            />
            <span className="error">{errors.arquivo?.message}</span>
          </Grid>
          <Grid item lg={6} md={6} sm={12} sx={12} className="field">
            <label>Alinhamento da imagem</label>
            <SelectBgAlinhamento inputName="alinhamento" register={register} />
            <span className="error">{errors.alinhamento?.message}</span>
          </Grid>
          <Grid item lg={12} md={12} sm={12} sx={12} className="field">
            <label>Legenda</label>
            <input type="text" {...register("nome")} />
            <span className="error">{errors.nome?.message}</span>
          </Grid>
          <Grid item lg={6} md={6} sm={6} sx={12} className="field">
            <label>Label do botão</label>
            <input type="text" {...register("botaoLabel")} />
            <span className="error">{errors.botaoLabel?.message}</span>
          </Grid>
          <Grid item lg={6} md={6} sm={6} sx={12} className="field">
            <label>Link do botão</label>
            <input type="text" {...register("botaoLink")} />
            <span className="error">{errors.botaoLink?.message}</span>
          </Grid>
        </Grid>
        <div className="actions">
          <button type="submit" className="save">
            Salvar
          </button>
          <a
            href="#"
            className="cancel"
            onClick={() => {
              setOpenModalNew(false);
            }}
          >
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
